// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2TMKD","row":"ProcedureTreatmentSummary_row__2OIMF"};